// src/lib/lead/coach/coachManager.ts
import type { Lead } from "@/types/lead";
import type { TextHeuristics } from "@/lib/lead/extraction/textHeuristics";

export type CoachResult = {
  coachKey: string;
  message: string | null;
};

export function buildCoachMessage(
  lead: Lead | null,
  h: Pick<TextHeuristics, "normalizePhone">,
  brandName: string,
): CoachResult {
  if (!lead || lead.isTest || !lead.extracted) return { coachKey: "", message: null };

  const e = lead.extracted;

  const issues: string[] = [];

  if (!e.phone || h.normalizePhone(e.phone).length < 10) issues.push("Ask for the customer’s phone number.");
  if (!e.first_name) issues.push("Ask for the customer’s first name.");
  if (e.email && !e.email.includes("@")) issues.push("That email looks incomplete. Confirm it with the customer.");
  if (!e.lead_source_category) {
    issues.push(`Ask how they found ${brandName}. Facebook, Google, drive-by, or referral.`);
  }
  if (!e.ready_to_buy_timeline || e.ready_to_buy_timeline === "unknown") issues.push("Ask when they want to buy. This week, this month, or later.");

  if (issues.length === 0) return { coachKey: "", message: null };

  const coachKey = [
    lead.id,
    String(!!e.first_name),
    String(h.normalizePhone(e.phone).length >= 10),
    String(!!e.lead_source_category),
    String(!!e.ready_to_buy_timeline && e.ready_to_buy_timeline !== "unknown"),
    String(!!e.email && e.email.includes("@")),
  ].join("|");

  return { coachKey, message: issues.slice(0, 2).join(" ") };
}